import { Stack } from "@mui/material";
import { DataGridPro, GridColumns } from "@mui/x-data-grid-pro";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import SelfDiagnosisRequestAPI from "../../api/self-diagnosis-request";
import { SelfDiagnosisRequest } from "../../graphql/API";

export default function SelfDiagnosisRequestList() {
  const dispatch = useDispatch();

  const selfDiagnosisRequestAPI = new SelfDiagnosisRequestAPI();

  const [items, setItems] = useState<SelfDiagnosisRequest[]>([]);

  useEffect(() => {
    initialize();
  }, []);

  async function initialize() {
    const data = await selfDiagnosisRequestAPI.listByYearMonth(
      dayjs().format("YYYYMM")
    );
    setItems(data);
  }

  const columns: GridColumns<SelfDiagnosisRequest> = [
    {
      field: "designerName",
      headerName: "디자이너 이름",
      valueGetter(params) {
        return params.row.designerName;
      },
    },
    {
      field: "shopName",
      headerName: "매장",
      flex: 1,
      valueGetter(params) {
        return params.row.shopName;
      },
    },
    {
      field: "date",
      headerName: "생성일",
      minWidth: 120,
      valueGetter(params) {
        return params.value;
      },
    },
    {
      field: "name",
      headerName: "고객 이름",
      flex: 1.5,
      valueGetter(params) {
        return params.row.name;
      },
    },
    {
      field: "writtenAt",
      headerName: "진단지 수신",
      flex: 1.5,
      valueGetter(params) {
        return params.row.writtenAt;
      },
    },
  ];

  return (
    <>
      <Container>
        <Row>
          <Col>
            <h4>APP 셀프 진단지 발송 기록</h4>
            <DataGridPro
              columns={columns}
              rows={items.map((item) => {
                return {
                  ...item,
                };
              })}
              autoHeight={true}
              components={{
                NoRowsOverlay: () => (
                  <Stack
                    height="100%"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ textAlign: "center" }}
                  >
                    데이터가 없습니다.
                  </Stack>
                ),
              }}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
}
